/**
 * 센터 초기화 React Query mutation 훅
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "@/config/firebase";

interface ResetCenterRequest {
  centerId: number;
}

interface ResetCenterResponse {
  success: true;
}

/**
 * 센터 초기화 mutation
 * 센터의 모든 하위 데이터를 삭제하고 기본값으로 재초기화한다.
 */
export function useResetCenter() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (request: ResetCenterRequest) => {
      const fn = httpsCallable<ResetCenterRequest, ResetCenterResponse>(
        getFirebaseFunctions(),
        "resetCenter",
      );
      const result = await fn(request);
      return result.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["centers"] });
      queryClient.invalidateQueries({ queryKey: ["studiomate"] });
    },
  });
}
